import { Skeleton } from '@/components/ui/skeleton';
import { PendingRegion } from '@/shared/components/PendingRegion';
import { BAR_HEIGHT, BAR_HEIGHT_INLINE } from '@/shared/components/barScale';

/**
 * The Models tab's shape while it loads (spec 233 FR-013): the Runs by profile card,
 * then three ledger rows, laid out as they will be, so nothing moves further than the
 * row count when the data lands.
 */
export function AiModelsSkeleton() {
  return (
    <PendingRegion label="Loading AI models" className="flex flex-col gap-4">
      <div className="border-border bg-card flex flex-col gap-3 rounded-lg border p-4">
        <Skeleton className="h-3 w-32 rounded-sm" />
        <Skeleton className={`${BAR_HEIGHT} w-full rounded-full`} />
        <div className="flex flex-wrap gap-5">
          {Array.from({ length: 3 }, (_, item) => (
            <Skeleton key={item} className="h-4 w-28 rounded-sm" />
          ))}
        </div>
      </div>
      <div className="border-border bg-card flex flex-col gap-3 rounded-lg border p-4">
        <Skeleton className="h-3 w-24 rounded-sm" />
        <div className="divide-border flex flex-col divide-y">
          {Array.from({ length: 3 }, (_, row) => (
            <div key={row} className="flex items-center gap-3 py-3">
              <Skeleton className="size-6 shrink-0 rounded-md" />
              <Skeleton className="h-4 w-40 max-w-full rounded-sm" />
              <Skeleton
                className={`ms-auto ${BAR_HEIGHT_INLINE} w-28 rounded-full`}
              />
            </div>
          ))}
        </div>
      </div>
    </PendingRegion>
  );
}
